// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-UserMenu-UserMenu-module__menuContainer--ZPZ6d,
.src-components-UserMenu-UserMenu-module__userMenu--pFYaU {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  cursor: pointer;
}
.src-components-UserMenu-UserMenu-module__menuContainer--ZPZ6d .src-components-UserMenu-UserMenu-module__avatar--MZ8m4,
.src-components-UserMenu-UserMenu-module__userMenu--pFYaU .src-components-UserMenu-UserMenu-module__avatar--MZ8m4 {
  color: #343a41;
}
.src-components-UserMenu-UserMenu-module__menuContainer--ZPZ6d .src-components-UserMenu-UserMenu-module__arrow--aHw5L,
.src-components-UserMenu-UserMenu-module__userMenu--pFYaU .src-components-UserMenu-UserMenu-module__arrow--aHw5L {
  transition: transform 0.3s;
  color: #343a41;
}
.src-components-UserMenu-UserMenu-module__menuContainer--ZPZ6d:hover .src-components-UserMenu-UserMenu-module__arrow--aHw5L,
.src-components-UserMenu-UserMenu-module__userMenu--pFYaU:hover .src-components-UserMenu-UserMenu-module__arrow--aHw5L {
  color: #343a41;
}
.src-components-UserMenu-UserMenu-module__menuContainer--ZPZ6d:hover .src-components-UserMenu-UserMenu-module__avatar--MZ8m4,
.src-components-UserMenu-UserMenu-module__userMenu--pFYaU:hover .src-components-UserMenu-UserMenu-module__avatar--MZ8m4 {
  color: #343a41;
}
.src-components-UserMenu-UserMenu-module__userMenu--pFYaU {
  gap: 16px;
}
.src-components-UserMenu-UserMenu-module__userName--aFmHd {
  font-size: 14px;
  color: #343a41;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
}
.src-components-UserMenu-UserMenu-module__userAvatar--UMzMr {
  width: 32px;
  height: 32px;
}
.src-components-UserMenu-UserMenu-module__open--iNNs3 {
  transform: rotate(180deg);
}
.src-components-UserMenu-UserMenu-module__menu--AJKYC {
  position: absolute;
  top: 100%;
  right: 0;
  display: inline-block;
  z-index: 1000;
  box-shadow: 0px 2px 10px 0px #00000026;
  background-color: white;
  margin: 0;
  padding: 8px 0;
}
.src-components-UserMenu-UserMenu-module__menu--AJKYC .src-components-UserMenu-UserMenu-module__menuItem--ftGbR a,
.src-components-UserMenu-UserMenu-module__menu--AJKYC .src-components-UserMenu-UserMenu-module__menuItem--ftGbR button {
  font-size: 16px;
  display: inline-block;
  color: #343a41;
  text-decoration: none;
  margin: 0;
  width: max-content;
  height: 44px;
  padding: 12px 14px;
  text-align: left;
  transition: 0.3s;
  line-height: 20px;
}
.src-components-UserMenu-UserMenu-module__menu--AJKYC .src-components-UserMenu-UserMenu-module__menuItem--ftGbR a:hover,
.src-components-UserMenu-UserMenu-module__menu--AJKYC .src-components-UserMenu-UserMenu-module__menuItem--ftGbR button:hover {
  background-color: white;
  color: #343a41;
}
.src-components-UserMenu-UserMenu-module__menu--AJKYC .src-components-UserMenu-UserMenu-module__menuItem--ftGbR a:focus,
.src-components-UserMenu-UserMenu-module__menu--AJKYC .src-components-UserMenu-UserMenu-module__menuItem--ftGbR button:focus {
  background-color: white !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/UserMenu/UserMenu.module.less"],"names":[],"mappings":"AAEA;;EAEE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AADF;AALA;;EAQI,cAAA;AACJ;AATA;;EAWI,0BAAA;EACA,cAAA;AAEJ;AAAE;;EAEI,cAAA;AAEN;AAJE;;EAKI,cAAA;AAGN;AACA;EACE,SAAA;AACF;AACA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AACF;AAEA;EACE,WAAA;EACA,YAAA;AAAF;AAGA;EACE,yBAAA;AADF;AAIA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;EACA,aAAA;EACA,sCAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;AAFF;AAPA;;EAaM,eAAA;EACA,qBAAA;EACA,cAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAFN;AAGM;;EACE,uBAAA;EACA,cAAA;AAAR;AAEM;;EACE,kCAAA;AACR","sourcesContent":["@import \"/src//variables.less\";\n\n.menuContainer,\n.userMenu {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  position: relative;\n  cursor: pointer;\n  .avatar {\n    color: @text-main;\n  }\n  .arrow {\n    transition: transform 0.3s;\n    color: @text-main;\n  }\n  &:hover {\n    .arrow {\n      color: @text-main;\n    }\n    .avatar {\n      color: @text-main;\n    }\n  }\n}\n.userMenu {\n  gap: 16px;\n}\n.userName {\n  font-size: 14px;\n  color: @text-main;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0px;\n}\n\n.userAvatar {\n  width: 32px;\n  height: 32px;\n}\n\n.open {\n  transform: rotate(180deg);\n}\n\n.menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  display: inline-block;\n  z-index: 1000;\n  box-shadow: 0px 2px 10px 0px #00000026;\n  background-color: white;\n  margin: 0;\n  padding: 8px 0;\n  .menuItem {\n    a,\n    button {\n      font-size: 16px;\n      display: inline-block;\n      color: @text-main;\n      text-decoration: none;\n      margin: 0;\n      width: max-content;\n      height: 44px;\n      padding: 12px 14px;\n      text-align: left;\n      transition: 0.3s;\n      line-height: 20px;\n      &:hover {\n        background-color: white;\n        color: @text-main;\n      }\n      &:focus {\n        background-color: white !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuContainer": `src-components-UserMenu-UserMenu-module__menuContainer--ZPZ6d`,
	"userMenu": `src-components-UserMenu-UserMenu-module__userMenu--pFYaU`,
	"avatar": `src-components-UserMenu-UserMenu-module__avatar--MZ8m4`,
	"arrow": `src-components-UserMenu-UserMenu-module__arrow--aHw5L`,
	"userName": `src-components-UserMenu-UserMenu-module__userName--aFmHd`,
	"userAvatar": `src-components-UserMenu-UserMenu-module__userAvatar--UMzMr`,
	"open": `src-components-UserMenu-UserMenu-module__open--iNNs3`,
	"menu": `src-components-UserMenu-UserMenu-module__menu--AJKYC`,
	"menuItem": `src-components-UserMenu-UserMenu-module__menuItem--ftGbR`
};
export default ___CSS_LOADER_EXPORT___;
